<div style="display: flex">
    <p-dialog header="Are you sure?" [(visible)]="areYouSure"
        [closable]="false" [closeOnEscape]="false" [style]="{width: '30vw', height: '30vh' }">
        <label>A Merge action requires careful consideration as it merges time and expense entries only. If the task or item has been included in period processing, that information i.e. invoice detail, is not merged. We highly recommend consulting with your eFAACT Advisor or accountant BEFORE taking this action.</label>
        <ng-template #footer >
            <button pButton type="button" class="p-button-text" label="Merge" (click)="mergeClicked()"></button>
            <button pButton type="button" class="p-button-text p-button-danger" label="Cancel" (click)="areYouSure = false"></button>
        </ng-template>
    </p-dialog>
</div>
<p-card styleClass="w-full p-card-shadow my-5 surface-100">
    <p-card header="Type" styleClass="w-full p-card-shadow">
        <div style="padding: 1em">
            <p-floatLabel variant="on">
                <p-select
                    styleClass="w-full"
                    appendTo="body"
                    [options]="types"
                    [(ngModel)]="selectedType"
                    [filter]="false"
                    [autoDisplayFirst]="false"
                    id="type"
                    (onChange)="onChangeType($event)"
                >
                </p-select>
                <label for="float-ad">Type</label>
            </p-floatLabel>
        </div>
    </p-card>

    <div class="grid my-2">
        <div class="col">
            <p-card header="From" styleClass="w-full p-card-shadow">
                <div style="padding: 1em">
                    <p-floatLabel variant="on">
                        <p-select
                            styleClass="w-full"
                            appendTo="body"
                            [options]="typeItems"
                            [(ngModel)]="selectedItemFrom"
                            [virtualScroll]="true"
                            [filter]="true"
                            [autoDisplayFirst]="false"
                            id="type"
                            (onChange)="onChangeFrom($event)"
                        >
                        </p-select>
                        <label for="float-bd">From</label>
                    </p-floatLabel>
                </div>
            </p-card>
        </div>

        <div class="w-5rem flex align-self-center justify-content-center">
            <i class="pi pi-arrow-right" style="font-size: 40px; color: black;"></i>
        </div>

        <div class="col">
            <p-card header="Final" styleClass="w-full p-card-shadow">
                <div style="padding: 1em">
                    <p-floatLabel variant="on">
                        <p-select
                            styleClass="w-full"
                            appendTo="body"
                            [options]="typeItems"
                            [(ngModel)]="selectedItemFinal"
                            [virtualScroll]="true"
                            [filter]="true"
                            [autoDisplayFirst]="false"
                            id="type"
                            (onChange)="onChangeFinal($event)"
                        >
                        </p-select>
                        <label for="float-cd">Final</label>
                    </p-floatLabel>
                </div>
            </p-card>
        </div>

    </div>

    <ng-template pTemplate="footer">
        <div class="grid">
            <div class="col-10">
                <p-message *ngIf="this.IsSuccess == false && this.ShowStatus == true" severity="error" [text]="this.merge[0].Status.Message"></p-message>
                <p-message *ngIf="this.IsSuccess == true && this.ShowStatus == true" severity="success" [text]="this.merge[0].Status.Message"></p-message>
            </div>
            <div class="col-2">
                <button pButton type="button" class="p-button-primary" style="width: 90%; min-width: 6rem; font-size: 1.25em;" label="Merge" (click)="areYouSure = true"></button>
            </div>
        </div>
    </ng-template>
</p-card>

